import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ConfigProvider } from '@mydocma/common';
import { TASK_CONFIG, WEBSOCKET_CONFIG } from '@mydocma/task';
import { AUTHSETTINGS, AUTHSTORAGE } from '@mydocma/auth';
import { APP_CONTAINER_SETTINGS } from '@mydocma/app-container';
import { MYDOCMASETTINGS } from '@mydocma/core';
import { BP_CONFIG, BpConfig } from '@mydocma/co/src/lib/common';

if (environment.production) {
  enableProdMode();
}

async function main() {

  try {
    const configProvider = new ConfigProvider<BpConfig>(null);
    const config = await configProvider.loadConfigAsync();

    await platformBrowserDynamic([
    //we could do it here or in app-module

    { provide: TASK_CONFIG, useValue: config.taskConfig },
    { provide: WEBSOCKET_CONFIG, useValue: config.webSocketConfig },
    { provide: AUTHSETTINGS, useValue: config.authConfig },
    { provide: AUTHSTORAGE, useValue: sessionStorage },
    { provide: MYDOCMASETTINGS, useValue: config.mydocmaConfig },
    { provide: APP_CONTAINER_SETTINGS, useValue: config.appContainerConfig },
    { provide: BP_CONFIG, useValue: {...config.bpConfig, parentApp: config.appName}},



    ]).bootstrapModule(AppModule).then(() => {
      /*if ('serviceWorker' in navigator && environment.production) {
        navigator.serviceWorker.register('ngsw-worker.js');
      }*/
    })
  } catch (error) {
    console.error(error);
  }
}

main()
